import React, { useEffect } from 'react';
import './MessageCodes.css';

const MessageA3Auto = (props) => {
    useEffect(() => {
        if (props?.item?._processed) return;
        props.item._processed = true;

        props?.addMessages(props?.data, props?.item?.code, '', null, null);
    }, []);

    return (
        <div style={{ width: 'fit-content' }}>
            <div
                id="main-tab1"
                style={{ padding: '4px' }}
                className="A3f html-sanitizer"
                dangerouslySetInnerHTML={{ __html: props.item.text }}
            />
        </div>
    );
};

export default MessageA3Auto;
